// Task page, checklist and areas (task 1.2, D-028).
export const tenaxTasksEnglishMessages = {
  tenax: {
    today: {
      title: "Today",
      person: "Tasks of",
      me: "Me",
      empty: "Nothing due in the next 7 days",
      closed: "Task closed",
      open_steps:
        "%{smart_count} step not ticked |||| %{smart_count} steps not ticked",
      no_signals: "No alerts",
      sections: {
        overdue: "Overdue",
        today: "Today",
        week: "Next 7 days",
        automatic: "Automatic follow-ups",
        following: "Following",
        signals: "Alerts",
      },
    },
    tasks: {
      title: "Tasks",
      new: "New task",
      created: "Task created",
      empty: "No tasks here",
      fields: {
        title: "Title",
        description: "Description",
        area: "Area",
        no_area: "No area",
        assignee: "Owner",
        due_date: "Due date",
        priority: "Priority",
        type: "Type",
        status: "Status",
        steps: "Steps",
        steps_hint: "One per line: you can paste a Trello checklist",
      },
      filters: {
        mine: "Mine",
        everyone: "Everyone",
        all_areas: "All areas",
        open: "Open",
        done: "Done",
        cancelled: "Cancelled",
      },
      groups: {
        overdue: "Overdue",
        today: "Today",
        upcoming: "Upcoming",
        no_date: "No due date",
        closed: "Closed",
      },
      status: {
        todo: "To do",
        in_progress: "In progress",
        waiting: "Waiting",
        done: "Done",
        cancelled: "Cancelled",
      },
      priority: {
        1: "High",
        2: "Normal",
        3: "Low",
      },
      actions: {
        open: "Open",
        done: "Mark as done",
        reopen: "Reopen",
        cancel: "Cancel task",
        back: "Back to tasks",
      },
      checklist: {
        title: "Steps",
        progress: "%{done} of %{total}",
        add: "Add step",
        add_placeholder: "New step (paste several lines to add more)",
        ticked_by: "%{name}, %{date}",
        move_up: "Move up",
        move_down: "Move down",
        remove: "Remove step",
        empty: "No steps yet",
      },
      areas: {
        manage: "Areas",
        title: "Task areas",
        hint: "An area in use is not deleted: it is turned off.",
        add: "Add area",
        name: "Area name",
        active: "Active",
        inactive: "Off",
        turn_off: "Turn off",
        turn_on: "Turn on",
        move_up: "Move up",
        move_down: "Move down",
      },
      templates: {
        manage: "Templates",
        title: "Checklist templates",
        hint: "A template in use is not deleted: it is turned off. Changing a template does not change the tasks already created.",
        new_name: "New template name",
        add: "Add template",
        edit: "Edit template",
        name: "Name",
        description: "Description",
        default_area: "Default area",
        default_assignee: "Default owner",
        no_assignee: "Whoever creates the task",
        procedure: "Procedure",
        no_procedure: "No procedure",
        steps: "Template steps",
        steps_count: "%{count} steps",
        from_template: "From template",
        none: "No template",
        turn_off: "Turn off",
        turn_on: "Turn on",
        inactive: "Off",
      },
      procedures: {
        title: "Procedures",
        open: "Procedure",
        new_title: "New procedure title",
        add: "Add procedure",
        edit: "Edit",
        preview: "Preview",
        body: "Text (Markdown)",
        empty: "No procedures yet",
        empty_body: "This procedure has no text yet.",
        back: "Back to procedures",
        saved: "Procedure saved",
      },
      errors: {
        relink:
          "A task cannot move to another contact or record: create a new task.",
      },
    },
  },
};

export const tenaxTasksItalianMessages = {
  tenax: {
    today: {
      title: "Oggi",
      person: "Attività di",
      me: "Io",
      empty: "Niente in scadenza nei prossimi 7 giorni",
      closed: "Attività chiusa",
      open_steps:
        "%{smart_count} passaggio non spuntato |||| %{smart_count} passaggi non spuntati",
      no_signals: "Nessuna segnalazione",
      sections: {
        overdue: "In ritardo",
        today: "Oggi",
        week: "Prossimi 7 giorni",
        automatic: "Follow-up automatici",
        following: "Che segui",
        signals: "Segnalazioni",
      },
    },
    tasks: {
      title: "Attività",
      new: "Nuova attività",
      created: "Attività creata",
      empty: "Nessuna attività qui",
      fields: {
        title: "Titolo",
        description: "Descrizione",
        area: "Area",
        no_area: "Senza area",
        assignee: "Responsabile",
        due_date: "Scadenza",
        priority: "Priorità",
        type: "Tipo",
        status: "Stato",
        steps: "Passaggi",
        steps_hint: "Uno per riga: puoi incollare la checklist di Trello",
      },
      filters: {
        mine: "Le mie",
        everyone: "Tutto il team",
        all_areas: "Tutte le aree",
        open: "Aperte",
        done: "Fatte",
        cancelled: "Annullate",
      },
      groups: {
        overdue: "In ritardo",
        today: "Oggi",
        upcoming: "Prossime",
        no_date: "Senza scadenza",
        closed: "Chiuse",
      },
      status: {
        todo: "Da fare",
        in_progress: "In corso",
        waiting: "In attesa",
        done: "Fatta",
        cancelled: "Annullata",
      },
      priority: {
        1: "Alta",
        2: "Normale",
        3: "Bassa",
      },
      actions: {
        open: "Apri",
        done: "Segna come fatta",
        reopen: "Riapri",
        cancel: "Annulla l'attività",
        back: "Torna alle attività",
      },
      checklist: {
        title: "Passaggi",
        progress: "%{done} di %{total}",
        add: "Aggiungi passaggio",
        add_placeholder:
          "Nuovo passaggio (incolla più righe per aggiungerne tanti)",
        ticked_by: "%{name}, %{date}",
        move_up: "Sposta su",
        move_down: "Sposta giù",
        remove: "Togli il passaggio",
        empty: "Ancora nessun passaggio",
      },
      areas: {
        manage: "Aree",
        title: "Aree delle attività",
        hint: "Un'area usata non si cancella: si disattiva.",
        add: "Aggiungi area",
        name: "Nome dell'area",
        active: "Attiva",
        inactive: "Disattivata",
        turn_off: "Disattiva",
        turn_on: "Riattiva",
        move_up: "Sposta su",
        move_down: "Sposta giù",
      },
      templates: {
        manage: "Modelli",
        title: "Modelli di checklist",
        hint: "Un modello usato non si cancella: si disattiva. Cambiare un modello non cambia le attività già create.",
        new_name: "Nome del nuovo modello",
        add: "Aggiungi modello",
        edit: "Modifica il modello",
        name: "Nome",
        description: "Descrizione",
        default_area: "Area di default",
        default_assignee: "Responsabile di default",
        no_assignee: "Chi crea l'attività",
        procedure: "Procedura",
        no_procedure: "Nessuna procedura",
        steps: "Passaggi del modello",
        steps_count: "%{count} passaggi",
        from_template: "Da modello",
        none: "Nessun modello",
        turn_off: "Disattiva",
        turn_on: "Riattiva",
        inactive: "Disattivato",
      },
      procedures: {
        title: "Procedure",
        open: "Procedura",
        new_title: "Titolo della nuova procedura",
        add: "Aggiungi procedura",
        edit: "Modifica",
        preview: "Anteprima",
        body: "Testo (Markdown)",
        empty: "Ancora nessuna procedura",
        empty_body: "Questa procedura non ha ancora un testo.",
        back: "Torna alle procedure",
        saved: "Procedura salvata",
      },
      errors: {
        relink:
          "Un'attività non si sposta su un altro contatto o oggetto: creane una nuova.",
      },
    },
  },
};
